




































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import ProbabilisticChart from '@/modules/lcca/views/components/ProbablisticChart.vue';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import QuickHelp from '@/views/components/input/QuickHelp.vue';
import { UnitSystem } from '@/interfaces/units';
import { lccaStore } from '@/store/store';
import { IPerRoadScenarioImperial, PrRoadwayClassifications } from '@/modules/perRoad/interfaces/perRoad';
import { aadtDistByRoadClass } from '@/modules/perRoad/lib/roadwayFunctionalClassifications';
import PrVehicleDistributionPlot from '@/modules/perRoad/views/components/traffic/PrVehicleDistributionPlot.vue';

@Component({
  components: {
    PrVehicleDistributionPlot,
    QuickHelp,
    PxTextEntryBox,
    PxTextArea,
    ProbabilisticChart,
    PxDropdown,
    PxNumberInput,
  },
})
export default class SeasonRow extends Vue {
  @Prop() scenario!: IPerRoadScenarioImperial;

  @Prop() validations!: any;

  // @PropSync('alternative') alt!: ILccaAlternative;
  plotKey = 0;

  get pctAadtTotal() {
    return Number(this.scenario.vehiclesPctAadt.reduce((a, b) => a + b, 0).toFixed(2));
  }

  get aadtTotalRequiresNormalization() {
    return this.pctAadtTotal > 100.01 || this.pctAadtTotal < 99.99;
  }

  get roadwayClassificationOptions() {
    return Object.values(PrRoadwayClassifications).map((key) => ({ value: key, text: key }));
  }

  updateVehicleDistribution() {
    this.scenario.vehiclesPctAadt = aadtDistByRoadClass[this.scenario.roadwayClassification];
    this.sync();
  }

  updatePlotKey() {
    this.plotKey += 1;
  }

  sync() {
    this.updatePlotKey();
    this.$emit('sync');
  }

  syncCustomClass() {
    this.scenario.roadwayClassification = PrRoadwayClassifications.OTHER;
    this.updatePlotKey();
    this.$emit('sync');
  }

  unitSystemIsImperial() {
    return lccaStore.displayUnits === UnitSystem.Imperial;
  }

  normalizeAadt() {
    this.scenario.vehiclesPctAadt = this.scenario.vehiclesPctAadt.map((a) => {
      const x = a * (100 / this.pctAadtTotal);
      return Number(x.toFixed(2));
    });
    this.validations.$touch();
    this.sync();
  }
}
